export const EMAIL_SENT_PAGE = '/email-sent'
export const SIGN_UP = '/sign/up'
export const AUTHENTICATE_EMAIL = '/sign/auth/email'
export const ALERTS = '/alerts'
export const HOME = '/'
export const PLANS = '/plans'
export const PERMITS = '/permits'
export const TREE_PERMITS = '/trees'